import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ViewDashboard from "../Components/Dashboard/viewDashboard";

const DashBoardRoutes = () => {
   const { admin } = useSelector((state) => state.admin || {});
  const isLoggedIn = !!admin?.data?._id;

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  return (
    <Routes>
      {/* <Route path="/dashboard" element={<ViewDashboard />} /> */}
      <Route
        path="/dashboard"
        element={<ViewDashboard></ViewDashboard>}
      ></Route>
    </Routes>
  );
};

export default DashBoardRoutes;
